import { useQuery } from '@tanstack/react-query';

import { User } from '../../../../../types';
import { useRequestConstructor } from '../../../../hooks/useRequestConstructor';
import { unwrapPaginatedResponseDataAs } from '../../../../logic/unwrapPaginatedResponseDataAs';
import { PaginatedResponse } from '../../../../types/PaginatedResponse';
import { USER_BASE_PATH } from '../../constants/userBasePath';
import { getUsers } from '../../requests/getUsers';
import { UserSearchParams } from '../../types/UserSearchParams';

export const useUsers = (
  searchParams?: UserSearchParams,
  options?: { enabled?: boolean },
) => {
  const { constructGet } = useRequestConstructor();

  const { data, refetch, ...rest } = useQuery<
    PaginatedResponse<User[]> | undefined
  >({
    queryKey: [USER_BASE_PATH, searchParams],
    queryFn: () => getUsers(constructGet, searchParams),
    keepPreviousData: true,
    staleTime: 10000,
    ...options,
  });

  return {
    ...unwrapPaginatedResponseDataAs(data, refetch, 'users'),
    ...rest,
  };
};
